import {defineMessages} from 'react-intl';

const messages = defineMessages({
  somethingWentWrong: {
    id: 'crypto.payins.something_went_wrong_v2',
    defaultMessage: 'Something went wrong',
  },
  error404: {
    id: 'crypto.payins.error_404_v2',
    defaultMessage:
      'Oops! The link you have followed is as missing as Satoshi Nakamoto.',
  },
  error410: {
    id: 'crypto.payins.error_410_v2',
    defaultMessage:
      'Oops! This link has expired due to inactivity. Please go back and try again.',
  },
  testmodeBadgeLabel: {
    id: 'crypto.payins.testmode_badge_label',
    description:
      'Badge to alert merchants they are in the testmode environment',
    defaultMessage: 'TEST MODE',
  },
});
export default messages;
